<template>
    <div id="access_point_routes">
        <AccessPointFilter
            id="access_point_filter"
            :display-group-numbers="displayGroupNumbers"
            :reload="reload"
            :searches="searches"
            @change="handleSearch"
        />
        <AccessPointTable
            id="access_point_table"
            :display-group-numbers="displayGroupNumbers"
            :searches="searches"
            @change="displayGroupNumbers = !displayGroupNumbers"
            @reload="reload = !reload"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import AccessPointFilter from './AccessPointFilter';
    import AccessPointTable from './AccessPointTable';
    import './resources/styles/accessPointRoutes.scss';

    export default {
        name: 'AccessPointRoutes',
        components: {
            AccessPointTable,
            AccessPointFilter,
        },
        data() {
            return {
                displayGroupNumbers: false,
                reload: false,
                searches: [],
            };
        },
        created() {
            this.searches = [{ field: 8, value: 1, mode: 0 }];
        },
        methods: {
            handleSearch(searches) {
                this.searches = searches;
            },
        },
    };
</script>
